import { Injectable } from "@angular/core";
import { SgAriaMessage } from "../../../sg-base/sg-base-shared/models/sg-aria-message";
import { cloneDeep } from "lodash";

@Injectable({
    providedIn: 'root'
})

export class ResponseMsgUtils {

    /**
     * レスポンスメッセージ作成
     * @param {*} errors
     * @param {Array<SgAriaMessage>} errorMessageModelArray
     * @return {*}  {Array<SgAriaMessage>}
     * @memberof ResponseMsgUtils
     */
    public createResponseMsg(errors: any, errorMessageModelArray: Array<SgAriaMessage>): Array<SgAriaMessage> {
        // 返却用errorMessageModelArray
        let retErrorMessageModelArray: Array<SgAriaMessage> = new Array<SgAriaMessage>();
        retErrorMessageModelArray = cloneDeep(errorMessageModelArray);

        if (errors?.length > 0) {
            for (const error of errors) {
                if (error.message !== "" && error.message !== undefined && error.message !== null) {
                    // SGKE0始まりのエラーコードはI（情報）のため正常メッセージとして表示
                    if (error?.errorCode.startsWith('SGKE0')) {
                        retErrorMessageModelArray.push(this.showNormalMsg(error.message));
                        // SGKE1始まりのエラーコードはW（警告）のため警告メッセージとして表示
                    } else if (error?.errorCode.startsWith('SGKE1')) {
                        retErrorMessageModelArray.push(this.showWarningMsg(error.message));
                        // SGKE2始まりのエラーコードやその他コードはE（エラー）のためエラーメッセージとして表示
                    } else {
                        retErrorMessageModelArray.push(this.showErrorMsg(error.message));
                    }
                }
            }
        }
        // このメソッドでメッセージを追加したらretErrorMessageModelArrayを返却。追加しなかったら引数で受け取ったerrorMessageModelArrayをそのまま返却。
        // 理由：初期表示などでAPIを連続で呼ぶ場合、cloneDeepで生成した別インスタンスを返却すると2番目のAPIのメッセージが表示できなくなる問題が発生するため。
        return retErrorMessageModelArray?.length > errorMessageModelArray?.length ? retErrorMessageModelArray : errorMessageModelArray;
    }

    /**
     * 正常メッセージ出力
     * @param {string} message
     * @return {*}  {SgAriaMessage}
     * @memberof ResponseMsgUtils
     */
    public showNormalMsg(message: string): SgAriaMessage {

        // メッセージオブジェクトを作成
        let messageItem: SgAriaMessage = {
            message: message,
            messageClass: "mat-card-background-primary",
            icon: "done",
            iconClass: "mat-icon-color-primary"
        };

        return messageItem;
    }

    /**
     * 警告メッセージ出力
     * @param {string} message
     * @return {*}  {SgAriaMessage}
     * @memberof ResponseMsgUtils
     */
    public showWarningMsg(message: string): SgAriaMessage {

        // メッセージオブジェクトを作成
        let messageItem: SgAriaMessage = {
            message: message,
            messageClass: "mat-card-background-warning",
            icon: "warning",
            iconClass: "mat-icon-color-warning"
        };

        return messageItem;
    }

    /**
     * エラーメッセージ出力
     * @param {string} message
     * @return {*}  {SgAriaMessage}
     * @memberof ResponseMsgUtils
     */
    public showErrorMsg(message: string): SgAriaMessage {

        // メッセージオブジェクトを作成
        let messageItem: SgAriaMessage = {
            message: message,
            messageClass: "mat-card-background-error",
            icon: "cancel",
            iconClass: "mat-icon-color-error"
        };

        return messageItem;
    }

}
